import {httpPost} from '@/shared/api/serve';

import {ContactFormValues} from '../validations/contactUsForm';

export async function sendContactUsForm(
  payload: ContactFormValues
): Promise<void> {
  await httpPost('/contact/us', payload);
}
